import { gateway } from '../../api';

const CORE = process.env.REACT_APP_CORE;

export function getTipoAcordoSeguro() {
  return gateway.get(`${CORE}/tipos-acordo-seguro`);
}
